import React from 'react';
import styled from 'styled-components/macro';
import TippyToolTip from 'components/base/TippyToolTip/TippyToolTip';
import { ABBREVIATION_THRESHOLD } from 'helpers/abbreviateNumber';
import formatNumber from 'helpers/formatNumber';

const SocialMetricsWrapper = styled('div')<any>`
  max-height: 0px;
  overflow: hidden;
  transition: max-height 1.5s ease;
  transition-delay: 0s;

  ${({ isActive }): string =>
    isActive
      ? `max-height: 1000px;`
      : `
    transition-delay: -.75s;
  `}

  display: flex;
  flex-direction: column;
  margin: ${({ isSmallScreen }): string =>
    isSmallScreen ? `0 auto 10px auto` : '4px 0 0 40px'};
  ${({ isSmallScreen }): string => (isSmallScreen ? `` : 'min-width: 150px;')};
  max-width: ${({ isSmallScreen }): string =>
    isSmallScreen ? 'fit-content' : '280px'};

  @media only screen and (max-width: 42em) and (min-width: 40em) {
    margin-left: 10px;
  }
`;

const SocialRow = styled('div')`
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  width: fit-content;
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
  text-transform: uppercase;
`;

const IconWrapper = styled('div')`
  width: 20px;
  display: flex;
  justify-content: center;
  margin-right: 6px;
`;

const SocialMetrics = ({
  socialMetrics,
  isSmallScreen,
  isActive,
}: any): any => {
  if (!socialMetrics[0]) {
    return null;
  }

  return (
    <SocialMetricsWrapper isSmallScreen={isSmallScreen} isActive={isActive}>
      {socialMetrics.map((metric: any) => {
        const fullValue =
          metric.rawValue && formatNumber(metric.rawValue, 'full', false);

        return (
          <SocialRow key={metric.platformName}>
            <IconWrapper>
              <metric.icon />
            </IconWrapper>
            <span>
              {isSmallScreen ? (
                <span>{fullValue}</span>
              ) : (
                <TippyToolTip
                  enabled={
                    !!metric?.rawValue &&
                    Math.abs(metric?.rawValue) >= ABBREVIATION_THRESHOLD
                  }
                  tooltipContent={fullValue}
                  canBeCopied
                >
                  <span>{metric.value}</span>
                </TippyToolTip>
              )}
              {` ${metric.socialTitle}`}
            </span>
          </SocialRow>
        );
      })}
    </SocialMetricsWrapper>
  );
};

export default SocialMetrics;
